import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { logoutStaff } from '../../reducers/StaffAuth';
import { APP_LOGO, MENU_LABELS, ROUTES } from '../../config/constants';

const ECOSYSTEM_LINKS = [
  { label: 'Mindhosts', href: '#' },
  { label: 'LecturersClub', href: '#' },
  { label: 'Indlearn', href: '#' },
  { label: 'MindhostsPlus', href: '#' },
  { label: 'ITArmy', href: '#' },
  { label: 'Indversity', href: '#' },
  { label: 'Englishvoice', href: '#' },
];

class Header extends Component {
  state = { userMenuOpen: false };

  logout = () => {
    this.props.logoutStaff();
  };

  render() {
    const { name, username, organization_name, onToggleMobile } = this.props;
    const displayName = name || 'Member';
    const displayEmail = username || 'member@iaept.com';
    const orgName = organization_name || 'Indgiants Association of Educators & Professional Trainers - IAEPT';

    return (
      <div className="nk-header nk-header-fixed iaept-top-header">
        <div className="iaept-header-bar">
          <div className="iaept-header-col iaept-header-col-left">
            <button
              type="button"
              className="iaept-header-toggle d-xl-none"
              onClick={onToggleMobile}
              aria-label="Open menu"
            >
              <em className="icon ni ni-menu" />
            </button>
            <div className="iaept-header-welcome">
              <h5 className="iaept-welcome-title">Welcome to IAEPT Community</h5>
              <p className="iaept-welcome-sub">Access events, resources, meetings, and community programs.</p>
            </div>
          </div>

          <div className="iaept-header-col iaept-header-col-center d-none d-xl-flex">
            <div className="iaept-header-brand-row">
              <img src={APP_LOGO} alt="IAEPT" className="iaept-header-logo" />
              <span className="iaept-header-org">{orgName}</span>
            </div>
            <div className="iaept-header-ecosystem-row">
              {ECOSYSTEM_LINKS.map((link, i) => (
                <Fragment key={link.label}>
                  {i > 0 && <span className="iaept-eco-sep" aria-hidden="true">|</span>}
                  <a href={link.href} className="iaept-eco-link">{link.label}</a>
                </Fragment>
              ))}
            </div>
          </div>

          <div className="iaept-header-col iaept-header-col-right">
            <div className="iaept-header-user-wrap">
              <button
                type="button"
                className="iaept-header-user"
                onClick={() => this.setState((s) => ({ userMenuOpen: !s.userMenuOpen }))}
              >
                <div className="iaept-header-avatar">
                  <img src={APP_LOGO} alt={displayName} />
                </div>
                <div className="iaept-header-user-info d-none d-md-block">
                  <span className="iaept-user-name">{displayName}</span>
                  <span className="iaept-user-email">{displayEmail}</span>
                </div>
                <em className="icon ni ni-chevron-down iaept-user-caret d-none d-md-block" />
              </button>

              {this.state.userMenuOpen && (
                <div className="iaept-user-dropdown">
                  <Link to={ROUTES.SETTINGS} className="iaept-user-dropdown-item" onClick={() => this.setState({ userMenuOpen: false })}>
                    <em className="icon ni ni-user-alt" />
                    {MENU_LABELS.PROFILE}
                  </Link>
                  <button type="button" className="iaept-user-dropdown-item" onClick={() => this.logout()}>
                    <em className="icon ni ni-signout" />
                    Sign out
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  name: state.StaffAuth.name,
  username: state.StaffAuth.username,
  organization_name: state.StaffAuth.organization_name,
});

const mapDispatchToProps = (dispatch) => ({
  logoutStaff: () => logoutStaff(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
